import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M13.43 15.29c1.174 0 2.129.906 2.129 2.018v2.86c0 .24.2.431.458.437h1.857c1.463 0 2.653-1.122 2.653-2.5V9.992a1.54 1.54 0 0 0-.65-1.218l-6.424-4.89a2.44 2.44 0 0 0-2.933.002L4.14 8.773c-.422.306-.659.752-.664 1.235v8.097c0 1.378 1.19 2.5 2.653 2.5h1.875c.264 0 .478-.2.478-.445q0-.081.019-.16v-2.692c0-1.106.949-2.01 2.113-2.017zM17.875 22h-1.875c-1.074-.024-1.902-.829-1.902-1.831v-2.86c0-.344-.299-.623-.666-.623h-2.812c-.36.002-.657.282-.657.622v2.852q0 .105-.03.2c-.105.92-.93 1.64-1.928 1.64H6.129c-2.269 0-4.114-1.747-4.114-3.895v-8.104c.01-.924.456-1.77 1.227-2.328l6.367-4.878a3.954 3.954 0 0 1 4.754-.001l6.413 4.882a2.9 2.9 0 0 1 1.212 2.306v8.123c0 2.148-1.845 3.895-4.114 3.895",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }